import './index.less';

// style dependencies
import 'antd/lib/tag/style';
import 'antd/lib/button/style';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@whalecloud/fdx-theme-fdx/date-picker/index.tsx
// module id = 1166
// module chunks = 0